<template>
  <main>
    <h1>软件发布评审</h1>
    <p>测试版本号：{{ version_number }}</p>
    <!--  用户信息记录  -->
    <release-review-info @getInfoData="getInfoData"/>
    <el-divider></el-divider>
    <div class="selected">
      <el-select v-model="value" placeholder="请选择探头类型" @change="chooseProbeType">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <!--  提交图片以及意见  -->
    <router-view @getLinearData="getLinearData" @getConvexData="getConvexData" @getPhasedData="getPhasedData" />
    <el-button type="primary" class="commitButton" @click="commit">提交</el-button>
  </main>
</template>

<script>
import Global from '../components/Global.vue'
import ReleaseReviewInfo from "./release_review/ReleaseReviewInfo";

export default {
  name: 'ReleaseReview',
  components: {
    ReleaseReviewInfo
  },
  mounted() {
    this.$router.push({'name': 'ReleaseReviewForLinear'});
    let that = this;
    that.axios({
        method: 'GET',
        url: Global.accountUrl + '/releaseReview/getTestVersion'
      }
    ).then(
      function (response) {
        if (response.data.code == 200) {
          that.version_number = response.data.data.version_number;
        } else {
          that.$message.error('请求数据失败');
        }
      }
    )
  },
  data() {
    return {
      version_number: '0',
      formInline: {
        name: '',
        phone: '',
        probeSn: '',
        probeType: ''
      },
      options: [{
        value: 'linear',
        label: '线阵'
      },{
        value: 'convex',
        label: '凸阵'
      },{
        value: 'phased',
        label: '相控阵'
      }],
      value: 'linear',
      linear: {
        carotid_b_opinion: '',
        carotid_b_images: [],
        carotid_c_opinion: '',
        carotid_c_images: [],
        carotid_d_opinion: '',
        carotid_d_images: [],
        va_b_opinion: '',
        va_b_images: [],
        va_c_opinion: '',
        va_c_images: [],
        va_d_opinion: '',
        va_d_images: [],
        thyroid_b_long_opinion: '',
        thyroid_b_long_images: [],
        thyroid_c_long_opinion: '',
        thyroid_c_long_images: [],
        thyroid_b_short_opinion: '',
        thyroid_b_short_images: [],
        thyroid_c_short_opinion: '',
        thyroid_c_short_images: [],
        pv_b_opinion: '',
        pv_b_images: [],
        pv_c_opinion: '',
        pv_c_images: [],
        pv_d_opinion: '',
        pv_d_images: [],
        version_confirm: '',
        other_opinion: '',
        other_images: []
      },
      convex: {
        liver_b_opinion: '',
        liver_b_images: [],
        liver_c_opinion: '',
        liver_c_images: [],
        lk_b_opinion: '',
        lk_b_images: [],
        aa_b_opinion: '',
        aa_b_images: [],
        aa_c_opinion: '',
        aa_c_images: [],
        ivc_b_opinion: '',
        ivc_b_images: [],
        ivc_c_opinion: '',
        ivc_c_images: [],
        gb_b_opinion: '',
        gb_b_images: [],
        kidney_b_opinion: '',
        kidney_b_images: [],
        kidney_c_opinion: '',
        kidney_c_images: [],
        version_confirm: '',
        other_opinion: '',
        other_images: []
      },
      phased: {
        afc_b_opinion: '',
        afc_b_images: [],
        afc_c_opinion: '',
        afc_c_images: [],
        piv_b_long_opinion: '',
        piv_b_long_images: [],
        piv_c_long_opinion: '',
        piv_c_long_images: [],
        piv_m_long_opinion: '',
        piv_m_long_images: [],
        piv_pw_long_opinion: '',
        piv_pw_long_images: [],
        piv_b_short_opinion: '',
        piv_b_short_images: [],
        piv_c_short_opinion: '',
        piv_c_short_images: [],
        piv_m_short_opinion: '',
        piv_m_short_images: [],
        piv_pw_short_opinion: '',
        piv_pw_short_images: [],
        version_confirm: '',
        other_opinion: '',
        other_images: []
      }
    }
  },
  methods: {
    // 提交评审
    commit() {
      let that = this;
      if (that.value == 'linear') {
        that.axios({
          method: 'POST',
          url: Global.accountUrl + '/releaseReview/uploadReleaseReview',
          data: {
            name: that.formInline.name,
            phone: that.formInline.phone,
            probe_sn: that.formInline.probeSn,
            probe_type: that.formInline.probeType,
            carotid_b_opinion: that.linear.carotid_b_opinion,
            carotid_b_images: that.linear.carotid_b_images,
            carotid_c_opinion: that.linear.carotid_c_opinion,
            carotid_c_images: that.linear.carotid_c_images,
            carotid_d_opinion: that.linear.carotid_d_opinion,
            carotid_d_images: that.linear.carotid_d_images,
            va_b_opinion: that.linear.va_b_opinion,
            va_b_images: that.linear.va_b_images,
            va_c_opinion: that.linear.va_c_opinion,
            va_c_images: that.linear.va_c_images,
            va_d_opinion: that.linear.va_d_opinion,
            va_d_images: that.linear.va_d_images,
            thyroid_b_long_opinion: that.linear.thyroid_b_long_opinion,
            thyroid_b_long_images: that.linear.thyroid_b_long_images,
            thyroid_c_long_opinion: that.linear.thyroid_c_long_opinion,
            thyroid_c_long_images: that.linear.thyroid_c_long_images,
            thyroid_b_short_opinion: that.linear.thyroid_b_short_opinion,
            thyroid_b_short_images: that.linear.thyroid_b_short_images,
            thyroid_c_short_opinion: that.linear.thyroid_c_short_opinion,
            thyroid_c_short_images: that.linear.thyroid_c_short_images,
            pv_b_opinion: that.linear.pv_b_opinion,
            pv_b_images: that.linear.pv_b_images,
            pv_c_opinion: that.linear.pv_c_opinion,
            pv_c_images: that.linear.pv_c_images,
            pv_d_opinion: that.linear.pv_d_opinion,
            pv_d_images: that.linear.pv_d_images,
            version_confirm: that.linear.version_confirm,
            other_opinion: that.linear.other_opinion,
            other_images: that.linear.other_images
          }
        }).then(function (response) {
          if (response.data.code == 200) {
            that.$alert('您已经成功提交您的发布评审', '提交成功', {
              confirmButtonText: '确定'
            });
          } else {
            that.$message.error(response.data.data);
          }
        });
      }
      if (that.value == 'convex') {
        that.axios({
          method: 'POST',
          url: Global.accountUrl + '/releaseReview/uploadReleaseReviewForConvex',
          data: {
            name: that.formInline.name,
            phone: that.formInline.phone,
            probe_sn: that.formInline.probeSn,
            probe_type: that.formInline.probeType,
            liver_b_opinion: that.convex.liver_b_opinion,
            liver_b_images: that.convex.liver_b_images,
            liver_c_opinion: that.convex.liver_c_opinion,
            liver_c_images: that.convex.liver_c_images,
            lk_b_opinion: that.convex.lk_b_opinion,
            lk_b_images: that.convex.lk_b_images,
            aa_b_opinion: that.convex.aa_b_opinion,
            aa_b_images: that.convex.aa_b_images,
            aa_c_opinion: that.convex.aa_c_opinion,
            aa_c_images: that.convex.aa_c_images,
            ivc_b_opinion: that.convex.ivc_b_opinion,
            ivc_b_images: that.convex.ivc_b_images,
            ivc_c_opinion: that.convex.ivc_c_opinion,
            ivc_c_images: that.convex.ivc_c_images,
            gb_b_opinion: that.convex.gb_b_opinion,
            gb_b_images: that.convex.gb_b_images,
            kidney_b_opinion: that.convex.kidney_b_opinion,
            kidney_b_images: that.convex.kidney_b_images,
            kidney_c_opinion: that.convex.kidney_c_opinion,
            kidney_c_images: that.convex.kidney_c_images,
            version_confirm: that.convex.version_confirm,
            other_opinion: that.convex.other_opinion,
            other_images: that.convex.other_images
          }
        }).then(function (response) {
          if (response.data.code == 200) {
            that.$alert('您已经成功提交您的发布评审', '提交成功', {
              confirmButtonText: '确定'
            });
          } else {
            that.$message.error(response.data.data);
          }
        });
      }
      if (that.value == 'phased') {
        that.axios({
          method: 'POST',
          url: Global.accountUrl + '/releaseReview/uploadReleaseReviewForPhased',
          data: {
            name: that.formInline.name,
            phone: that.formInline.phone,
            probe_sn: that.formInline.probeSn,
            probe_type: that.formInline.probeType,
            afc_b_opinion: that.phased.afc_b_opinion,
            afc_b_images: that.phased.afc_b_images,
            afc_c_opinion: that.phased.afc_c_opinion,
            afc_c_images: that.phased.afc_c_images,
            piv_b_long_opinion: that.phased.piv_b_long_opinion,
            piv_b_long_images: that.phased.piv_b_long_images,
            piv_c_long_opinion: that.phased.piv_c_long_opinion,
            piv_c_long_images: that.phased.piv_c_long_images,
            piv_m_long_opinion: that.phased.piv_m_long_opinion,
            piv_m_long_images: that.phased.piv_m_long_images,
            piv_pw_long_opinion: that.phased.piv_pw_long_opinion,
            piv_pw_long_images: that.phased.piv_pw_long_images,
            piv_b_short_opinion: that.phased.piv_b_short_opinion,
            piv_b_short_images: that.phased.piv_b_short_images,
            piv_c_short_opinion: that.phased.piv_c_short_opinion,
            piv_c_short_images: that.phased.piv_c_short_images,
            piv_m_short_opinion: that.phased.piv_m_short_opinion,
            piv_m_short_images: that.phased.piv_m_short_images,
            piv_pw_short_opinion: that.phased.piv_pw_short_opinion,
            piv_pw_short_images: that.phased.piv_pw_short_images,
            version_confirm: that.phased.version_confirm,
            other_opinion: that.phased.other_opinion,
            other_images: that.phased.other_images
          }
        }).then(function (response) {
          if (response.data.code == 200) {
            that.$alert('您已经成功提交您的发布评审', '提交成功', {
              confirmButtonText: '确定'
            });
          } else {
            that.$message.error(response.data.data);
          }
        });
      }
    },
    // 获得线阵上传的数据
    getLinearData(data) {
      this.linear = data;
    },
    // 获得凸阵上传的数据
    getConvexData(data) {
      this.convex = data;
    },
    // 获得相控阵上传的数据
    getPhasedData(data) {
      this.phased = data;
    },
    // 得到用户的信息
    getInfoData(data) {
      this.formInline.name = data.name;
      this.formInline.phone = data.phone;
      this.formInline.probeSn = data.probeSn;
      this.formInline.probeType = data.probeType;
    },
    chooseProbeType(item) {
      if (item == 'linear') {
        this.$router.push({'name': 'ReleaseReviewForLinear'});
      }
      if (item == 'convex') {
        this.$router.push({'name': 'ReleaseReviewForConvex'});
      }
      if (item == 'phased') {
        this.$router.push({'name': 'ReleaseReviewForPhased'})
      }
    }
  },
}

</script>

<style scoped>
h1 {
  text-align: center;
}

.commitButton {
  display: block;
  margin: auto;
}

p {
  text-align: center;
}

.selected {
  max-width: 200px;
  margin: 15px auto;
}

</style>



// WEBPACK FOOTER //
// src/components/ReleaseReview.vue